module.exports = __webpack_public_path__ + "img/errorTips.6453336f.png";